function groupWorkableJobs() {
    const container = document.getElementById("whr_embed_hook");
    if (!container) return;

    const items = Array.from(container.querySelectorAll(".whr-item"));
    if (items.length === 0) return;

    const groups = new Map();

    items.forEach(item => {
        const titleEl = item.querySelector(".whr-title a");
        if (!titleEl) return;

        const title = titleEl.textContent.trim();
        const locationEl = item.querySelector(".whr-location");
        const location = locationEl ? locationEl.childNodes[locationEl.childNodes.length - 1].textContent.trim() : "";

        if (groups.has(title)) {
            groups.get(title).locations.push(location);
            item.remove();
        } else {
            groups.set(title, { element: item, locations: [location] });
        }
    });

    groups.forEach(({ element, locations }) => {
        const locationEl = element.querySelector(".whr-location");
        if (locationEl && locations.length > 1) {
            const uniqueLocations = [...new Set(locations)].sort();
            const span = locationEl.querySelector("span");
            locationEl.textContent = "";
            locationEl.appendChild(span);
            locationEl.appendChild(document.createTextNode(" " + uniqueLocations.join(", ")));
        }
    });
}

const observer = new MutationObserver((mutations, obs) => {
    const container = document.getElementById("whr_embed_hook");
    if (container && container.querySelector(".whr-item")) {
        obs.disconnect();
        groupWorkableJobs();
    }
});

document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("whr_embed_hook");
    if (container && container.querySelector(".whr-item")) {
        groupWorkableJobs();
    } else {
        observer.observe(document.body, { childList: true, subtree: true });
    }
    whr(document).ready(() => {
        whr_embed(714240, { "base": "jobs", "detail": "titles", "zoom": "country", "grouping": "none" });
    });
});
